<div class="multi-shipment">
  @if (formGroup) {
    <pdq-tabs-group variant="underline" [leftMargin]="'none'" (onChange)="onTabChange($event)">
      @for (tab of tabs; track tab.value) {
        <pdq-tab [label]="tab.label" [value]="tab.value" [active]="tab.value === activeTab"></pdq-tab>
      }
    </pdq-tabs-group>

    <div class="content">
      @switch (activeTab) {
        @case (MultiShipmentFormTab.SETTINGS) {
          <multi-shipment-settings-tab [formGroup]="formGroup"></multi-shipment-settings-tab>
        }
        @case (MultiShipmentFormTab.COMPONENTS) {
          <multi-shipment-components-tab [formGroup]="formGroup"></multi-shipment-components-tab>
        }
        @case (MultiShipmentFormTab.DISPLAY_CONDITIONS) {
          <multi-shipment-display-conditions-tab [formGroup]="formGroup"></multi-shipment-display-conditions-tab>
        }
        @case (MultiShipmentFormTab.DATE_PICKER) {
          <multi-shipment-date-picker-tab [formGroup]="formGroup"></multi-shipment-date-picker-tab>
        }
      }
    </div>
  }
</div>
